import { SET_LOCATION } from './action-types';

export default function filters(state = { query: {} }, action) {
  switch (action.type) {
    case SET_LOCATION:
      return action.location;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/modules/history/reducers.js